import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { curriedRemove, reargCurriedConcat } from '../../../../../utils';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../../common";
import { QUIZ_ATTEMPTS_API_ENDPOINT } from '../endpoints';
import { updateResourceState } from '../util';

const actions = createActions({
  ATTEMPTS: {
    API: {
      UPDATE: apiResourceActionCreator('attempts')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.put(`${QUIZ_ATTEMPTS_API_ENDPOINT}/${payload.attempt.id}`, authToken, payload, actions.attempts.api.update)

const configuration = {
  name: 'update',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: true
    })),
    success: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: false,
      result: fp.flow(
        curriedRemove((quizAttempt) => quizAttempt.id === action.payload.attempt.id),
        reargCurriedConcat(action.payload.attempt)
      )(state.attempts.result),
      error: null
    })),
    failed: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: false,
      error: action.payload.error
    }))
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/attempts/update.js